const PROFILE_URL = '/profiles/profile.json';

// Configuração padrão
const appConfig = {
  name: 'Barramento',
  title: 'Barramento',
  banner: {
    prefix: '',
    title: 'Barramento',
    suffix: 'Mercadologic',
    variant: ''
  },
  themes: {
    light: {
      primary: '#607d8b',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#56CA00',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
      background: '#fff',
    },
    dark: {
      primary: '#607d8b',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#56CA00',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
      background: 'black',
    },
  },
};

async function loadCustomAppConfig() {
  try {
    const response = await fetch(PROFILE_URL);

    if (response.ok) {
      const profile = await response.json();

      for (const key in profile) {
        if (Object.prototype.hasOwnProperty.call(profile, key)
          && Object.prototype.hasOwnProperty.call(appConfig, key)) {

          if (key == 'themes') {
            for (const property in profile[key]) {
              appConfig[key][property] = profile[key][property]
            }
            continue
          }

          if (profile[key]) {
            appConfig[key] = profile[key]
          }

        }
      }

    } else if (response.status !== 404) {
      console.warn(`Atenção: O arquivo de configuração foi encontrado, mas retornou o status: ${response.status}`);
    }
  } catch (error) {
    console.warn('Atenção: Erro ao tentar carregar a configuração dinâmica:', error);
  }
}

module.exports = {
  appConfig,
  loadCustomAppConfig
};
